module.exports = __webpack_public_path__ + "static/img/FI@2x.806950b5.jpg";